import { render, staticRenderFns } from "./ActivityManager.vue?vue&type=template&id=1540fc34&"
import script from "./ActivityManager.vue?vue&type=script&lang=ts&"
export * from "./ActivityManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports